import * as z from "zod";

/**
 * Inline write-back from the rec-business-info step. The merchant fills in
 * any team profile fields that were missing (address, owner name, owner
 * phone) so the subsequent provisionRecoverPhoneNumber RPC has
 * everything Bandwidth needs.
 *
 * All fields are optional — the handler only writes the keys that are
 * present, never clobbering existing values.
 */
export const saveTeamProfileFields = {
  name: "saveTeamProfileFields" as const,
  input: z.object({
    address: z
      .object({
        street1: z.string().min(1),
        street2: z.string().optional(),
        city: z.string().min(1),
        state: z.string().min(1),
        zip: z.string().min(1),
        country: z.string().min(1),
      })
      .optional(),
    adminName: z.string().min(1).optional(),
    adminPhone: z.string().min(1).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
